/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { TBrowserData } from '@/core/constants/event_types/base_mable_event';
import { Logger } from '@/shared/logger/logger';

import IdentityApiService from './identity_api';
import {
  CommonSessionAndOrBrowserResponse,
  PatchSessionAndOrBrowserRequest,
  PostSessionAndOrBrowserRequest,
} from './types';

import { TSessionData } from '../../constants/event_types/base_mable_event';

export type TCreateSessionAndOrBrowserDataInput = {
  browserChanged: boolean;
  browserData: TBrowserData;
  identityIdentifier: string;
  sessionData: TSessionData;
};

export type TUpdateSessionAndOrBrowserDataInput = {
  browserChanged: boolean;
  browserData: TBrowserData;
  identityIdentifier: string;
  sessionChanged: boolean;
  sessionData: TSessionData;
};

export const IdentityServiceHandler = {
  async createNewSessionAndOrBrowserData(
    newSdAndOrBdInput: TCreateSessionAndOrBrowserDataInput,
  ): Promise<CommonSessionAndOrBrowserResponse> {
    try {
      const request: PostSessionAndOrBrowserRequest = {
        browser: newSdAndOrBdInput.browserChanged
          ? newSdAndOrBdInput.browserData
          : { aid: newSdAndOrBdInput?.browserData?.aid },
        ii: newSdAndOrBdInput?.identityIdentifier,
        session: newSdAndOrBdInput?.sessionData,
      } as PostSessionAndOrBrowserRequest;
      const response: CommonSessionAndOrBrowserResponse =
        await IdentityApiService.createSessionAndOrBrowser(request);
      return response;
    } catch (error) {
      Logger.error('createNewSessionAndOrBrowserData error', error);
      return {
        identityUpdateDetected: false,
        success: false,
        updatededIi: newSdAndOrBdInput?.identityIdentifier,
        updatedIdentity: {
          cdfs: [],
          pids: {
            epik: [],
            fbclid: [],
            gacid: [],
            gbraid: [],
            gclid: [],
            ttclid: [],
            wbraid: [],
          },
        },
      };
    }
  },

  async updatedSessionAndOrBrowserData(
    updateSdAndOrBd: TUpdateSessionAndOrBrowserDataInput,
  ): Promise<CommonSessionAndOrBrowserResponse> {
    Logger.info('updatedSessionAndOrBrowserData', updateSdAndOrBd);
    try {
      const request: PatchSessionAndOrBrowserRequest = {
        browser: updateSdAndOrBd.browserChanged
          ? updateSdAndOrBd.browserData
          : null,
        ii: updateSdAndOrBd.identityIdentifier,
        session: updateSdAndOrBd.sessionChanged
          ? updateSdAndOrBd.sessionData
          : null,
        updatedBrowser: updateSdAndOrBd.browserChanged,
        updatedSession: updateSdAndOrBd.sessionChanged,
      } as PatchSessionAndOrBrowserRequest;
      const response: CommonSessionAndOrBrowserResponse =
        await IdentityApiService.updateSessionAndOrBrowser(request);
      return response;
    } catch (error) {
      Logger.error('createNewSessionAndOrBrowserData error', error);
      return {
        identityUpdateDetected: false,
        success: false,
        updatededIi: updateSdAndOrBd.identityIdentifier,
        updatedIdentity: {
          cdfs: [],
          pids: {
            epik: [],
            fbclid: [],
            gacid: [],
            gbraid: [],
            gclid: [],
            ttclid: [],
            wbraid: [],
          },
        },
      };
    }
  },
};
